import '../index.css';
export { default } from './PageRoutes';
export * from './PageRoutes';
